export const ONBOARDING_STEPS = Object.freeze({
  EMAIL_SEND_TIME: {
    name: 'daily_email_time',
    value: 1,
  },
  CUISINE_TYPES: {
    name: 'store_types',
    value: 2,
  },
  MOBILE_DOWNLOAD: {
    name: 'download_mobile_app',
    value: 3,
  },
  COMPLETE: {
    name: 'complete',
    value: 4,
  },
})

export const getOnboardingPercentage = (hasEmailTime, hasCuisineTypes, hasMobileApp) => {
  let percentage = 25
  if (hasEmailTime) percentage += 25
  if (hasCuisineTypes) percentage += 25
  if (hasMobileApp) percentage += 25

  return percentage
}

export const setHideOnboarding = userId => {
  const value = JSON.stringify({ userId, hide: true })
  localStorage.setItem('hideOnboarding', value)
}

const getHideOnboarding = () => {
  const stringValue = localStorage.getItem('hideOnboarding')
  return JSON.parse(stringValue)
}

export const userHidOnboarding = userId => {
  const hideOnboardingObj = getHideOnboarding()
  return hideOnboardingObj?.userId === userId && hideOnboardingObj?.hide
}
